export const UploaderStatus = {
	STARTED: 0,
	STOPPED: 1,
};